/* Aurora product recommendations — original, tiny.
   Dawn's product-recommendations.js isn't in this theme, so the <product-recommendations>
   custom element was never defined and complementary products never loaded.
   This fetches the recommendations URL on scroll-in and swaps in the rendered markup. */
(function () {
  if (customElements.get('aurora-recommendations')) return;

  customElements.define(
    'aurora-recommendations',
    class AuroraRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        var url = this.dataset.url;
        if (!url) return;

        var run = function () {
          if (this.loaded) return;
          this.loaded = true;
          fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (text) {
              var html = new DOMParser().parseFromString(text, 'text/html');
              // the fetched section re-renders THIS element with recommendations populated
              var fresh = html.querySelector('aurora-recommendations');
              var inner = fresh && fresh.innerHTML.trim();
              if (inner) {
                this.innerHTML = inner;
                // let the PDP script wire up the slider progress line on the injected markup
                document.dispatchEvent(new CustomEvent('aurora:reco:loaded', { detail: { el: this } }));
              } else {
                this.remove(); // no recommendations → don't leave an empty block
              }
            }.bind(this))
            .catch(function (e) { console.error('[aurora-recommendations]', e); });
        }.bind(this);

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { io.disconnect(); run(); }
            });
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(this);
        } else {
          run();
        }
      }
    }
  );
})();
